/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  eqeqeq,
  func-names,
  import/no-extraneous-dependencies,
  max-len,
  no-restricted-syntax,
  react/no-find-dom-node,
  react/prop-types
*/
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import watchAppNotifierMixin from 'common/components/mixins/watch-app-notifier';
import HfReactHelper from 'common/utils/hf-react-helper';
import classNames from 'classnames';
import createReactClass from 'create-react-class';
import bulkDot from './assets/bulk@2x.png';
import allteamDot from './assets/allteam@2x.png';
import outforsignatureDot from './assets/outforsignature@2x.png';
import awaitingDot from './assets/awaiting@2x.png';
import completedDot from './assets/completed@2x.png';
import declinedDot from './assets/declined@2x.png';
import templatesDot from './assets/templates@2x.png';
import templatelinksDot from './assets/templatelinks@2x.png';
import draftsDot from './assets/drafts@2x.png';
import sentDot from './assets/sent@2x.png';
import receivedDot from './assets/received@2x.png';


export const FILTERS = {
  documentsbulk: 'bulk',
  documentsallteam: 'all_team',
  documentsoutforsignature: 'out_for_signature',
  documentsawaiting: 'awaiting_my_signature',
  documentscompleted: 'completed',
  documentsdeclined: 'declined',
  documentstemplates: 'template',
  documentstemplatelinks: 'template_link',
  documentsdrafts: 'draft',
  documentssent: 'sent',
  documentsreceived: 'received',
};


// In-app left side menu
const AppLeftMenu = createReactClass({

  mixins: [watchAppNotifierMixin],

  propTypes: {
    siteCode: PropTypes.string.isRequired, // S or F
    pageSize: PropTypes.number, // List size
    searchBackend: PropTypes.string, // Type of search backend to use
    activeItemId: PropTypes.string, // Menu item currently active
    hasTeamFilter: PropTypes.bool, // Whether the user can view all team docs
    hasCompletedFilter: PropTypes.bool, // Whether the completed filter is visible currently
    emailAddress: PropTypes.string.isRequired, // Email address for the current user
    faxNumbers: PropTypes.array, // List of fax numbers
    name: PropTypes.string, // Name of the user
    bulkSendSplit: PropTypes.bool.isRequired,
    canAccessBulkSendUI: PropTypes.bool.isRequired,
    canAccessAdminConsole: PropTypes.bool,
  },


  getInitialState() {

    const isHf = HfReactHelper.HfSites.isHelloFax(this.props.siteCode);
    const defaultItemId = isHf ? 'sendfax' : 'signdocs';
    let activeItemId = (this.props.activeItemId || defaultItemId);

    // Convert filters to section item ref
    for (const k in FILTERS) {
      if (FILTERS[k] === activeItemId) {
        activeItemId = k;
        break;
      }
    }

    return {
      activeItemId,
      faxLines: this.props.app.user.getFaxLines(),
    };
  },

  componentDidMount() {

    const root = $(ReactDOM.findDOMNode(this));
    const self = this;

    $('.m-app-leftmenu--section--title > a, .m-app-leftmenu--section--item > a', root).click(function (evt) {

      if (evt.target.tagName === 'A' || evt.target.parentNode.tagName === 'A') {
        return;
      }

      evt.preventDefault();

      const el = $(this);
      let itemId = el.attr('id');

      if (!itemId) {
        itemId = el.parent().attr('id');
      }

      self.setState({
        activeItemId: itemId,
      });
    });
  },

  getItemClassName(sectionName, isItem) {
    let s = `m-app-leftmenu--section${isItem ? '--item' : ''}`;
    if ((sectionName === 'signdocs' && $.inArray(this.state.activeItemId, ['signjustme', 'signmeandothers', 'signjustothers']) >= 0)
            || (sectionName === 'templates' && $.inArray(this.state.activeItemId, ['createtemplate', 'createtemplatelink', 'usetemplate', 'usetemplatelink']) >= 0)
            || ((sectionName === 'documents' && $.inArray(this.state.activeItemId, Object.keys(FILTERS)) >= 0))) {
      s += ' is-expanded';
    } else if (this.state.activeItemId === sectionName) {
      s += ' is-active';
    }
    return s;
  },

  makeFilter(id, label, dotUrl = null) {

    const params = [`filter=${FILTERS[id]}`];
    if (this.props.searchBackend) {
      params.push(`search_backend=${this.props.searchBackend}`);
    }
    if (this.props.pageSize) {
      params.push(`page_size=${this.props.pageSize}`);
    }

    const site = HfReactHelper.HfSites.getSite(this.props.siteCode);
    const url = HfReactHelper.urlHelper(`home/manage?${params.join('&')}`, site);

    return (
      <div id={id} className={this.getItemClassName(id, true)}>
        <span className={'m-app-leftmenu--section--item--dot'}>
          { dotUrl && <img src={dotUrl} /> }
        </span>
        <a href={url}>{ label }</a>
      </div>
    );
  },

  render() {

    const isHf = HfReactHelper.HfSites.isHelloFax(this.props.siteCode);
    let templates;
    let sendFax;
    let recvFax;
    let getFreePages;
    let signDocs;
    let allTeamDocsFilter;
    let completedFilter;
    let faxNumbers;
    let siteSpecificFilters;
    let manageTeamLink;

    const meAndOthersParams = 'me=1';

    const site = HfReactHelper.HfSites.getSite(this.props.siteCode);
    const teamUrl = HfReactHelper.urlHelper('home/team', site);
    const createTemplateUrl = HfReactHelper.urlHelper('home/createTemplate', site);
    const createLinkUrl = HfReactHelper.urlHelper('home/createReusableLink', site);
    const sendFaxUrl = HfReactHelper.urlHelper('home/index', site);
    const recvFaxUrl = HfReactHelper.urlHelper('home/upgrade', site);
    const freePagesUrl = HfReactHelper.urlHelper('account/gettingStarted', site);
    const useTemplateUrl = HfReactHelper.urlHelper('home/manage?filter=template', site);
    const useLinkUrl = HfReactHelper.urlHelper('home/manage?filter=template_link', site);
    const justMeUrl = HfReactHelper.urlHelper('sign', site);
    const meAndOthersUrl = HfReactHelper.urlHelper(`home/request?${meAndOthersParams}`, site);
    const justOthersUrl = HfReactHelper.urlHelper('home/request', site);
    const bulkSendUrl = HfReactHelper.urlHelper('bulksend', site);
    const signUrl = HfReactHelper.urlHelper('home/index', site);
    const templateUrl = HfReactHelper.urlHelper('home/createReusableDocs', site);
    const docsUrl = HfReactHelper.urlHelper('home/manage', site);
    const integrationsUrl = HfReactHelper.urlHelper('home/myAccount?current_tab=integrations', site);
    let documentsName = 'Documents';
    let qaAttribute = '';

    if (isHf) {

      documentsName = 'Faxes';

      sendFax = (
        <div id='sendfax' className={this.getItemClassName('sendfax')}>
          <div className='m-app-leftmenu--section--title'>
            <a href={sendFaxUrl}><span>Send a fax</span></a>
          </div>
        </div>
      );

      if (this.props.showUpgradeButton == true) {
        recvFax = (
          <div id='recvfax' className={this.getItemClassName('recvfax')}>
            <div className='m-app-leftmenu--section--title'>
              <a href={recvFaxUrl}><span>Receive faxes</span></a>
            </div>
          </div>
        );
      } else {
        recvFax = '';
      }

      signDocs = (
        <div id='signdocs' className={this.getItemClassName('signdocs')}>
          <div className='m-app-leftmenu--section--title'>
            <a href={justOthersUrl}><span>Sign documents</span></a>
          </div>
        </div>
      );

      getFreePages = (
        <div id='getfreepages' className={`l-margin-t-50 ${this.getItemClassName('getfreepages')}`}>
          <div className='m-app-leftmenu--section--title'>
            <a href={freePagesUrl}><span>Get free pages</span></a>
          </div>
        </div>
      );
      if (this.props.hasTeamFilter) {
        allTeamDocsFilter = this.makeFilter('documentsallteam', 'All team faxes', allteamDot);
      }
      siteSpecificFilters = (
        <div className='m-app-leftmenu--section--items'>
          { allTeamDocsFilter }
          { this.makeFilter('documentssent', 'Sent', sentDot) }
          { this.makeFilter('documentsreceived', 'Received', receivedDot) }
          { this.makeFilter('documentsdrafts', 'Drafts', draftsDot) }
        </div>
      );

      if (this.state.faxLines && this.state.faxLines.length > 0) {

        const numbers = this.state.faxLines.map((faxLine, index) => {
          return <div key={index} className='m-app-leftmenu--fax-numbers--list--item'>{ faxLine.number }</div>;
        });

        const listClasses = classNames({
          'm-app-leftmenu--fax-numbers--list': true,
          'is-scrollable': (this.state.faxLines.length > 12),
        });

        faxNumbers = (
          <div className='m-app-leftmenu--fax-numbers'>
            <div className='m-app-leftmenu--fax-numbers--title'>{ this.state.faxLines.length > 1 ? 'YOUR FAX NUMBERS' : 'YOUR FAX NUMBER' }</div>
            <div className={listClasses}>
              { numbers }
            </div>
          </div>
        );
      }

    } else {

      signDocs = (
        <div id='signdocs' className={this.getItemClassName('signdocs')}>
          <div className='m-app-leftmenu--section--title'>
            <a href={signUrl}><span>Sign documents</span></a>
          </div>
          <div className='m-app-leftmenu--section--items'>
            <div id='signjustme' className={this.getItemClassName('signjustme', true)}>
              <a href={justMeUrl}>Just me</a>
            </div>
            <div id='signmeandothers' className={this.getItemClassName('signmeandothers', true)}>
              <a href={meAndOthersUrl}>Me &amp; others</a>
            </div>
            <div id='signjustothers' className={this.getItemClassName('signjustothers', true)}>
              <a href={justOthersUrl}>Just others</a>
            </div>
            { this.props.bulkSendSplit
              && <div id='signbulksend' className={this.getItemClassName('signbulksend', true)}>
                <a href={bulkSendUrl}>Bulk send</a>
              </div>
            }
          </div>
        </div>
      );

      templates = (
        <div id='templates' className={this.getItemClassName('templates')}>
          <div className='m-app-leftmenu--section--title m-app-leftmenu--templates'>
            <a href={templateUrl}><span>Templates</span></a>
          </div>
          <div className='m-app-leftmenu--section--items'>
            <div id='createtemplate' className={this.getItemClassName('createtemplate', true)}>
              <a href={createTemplateUrl}>Create template</a>
            </div>
            <div id='createtemplatelink' className={this.getItemClassName('createtemplatelink', true)}>
              <a href={createLinkUrl}>Create link</a>
            </div>
            <div id='usetemplate' className={this.getItemClassName('usetemplate', true)}>
              <a href={useTemplateUrl}>Use template</a>
            </div>
            <div id='usetemplatelink' className={this.getItemClassName('usetemplatelink', true)}>
              <a href={useLinkUrl}>Use link</a>
            </div>
          </div>
        </div>
      );

      if (this.props.hasTeamFilter) {
        allTeamDocsFilter = this.makeFilter('documentsallteam', 'All team documents', allteamDot);
      }
      if (this.props.hasCompletedFilter) {
        completedFilter = this.makeFilter('documentscompleted', 'Completed', completedDot);
      }
      siteSpecificFilters = (
        <div className='m-app-leftmenu--section--items'>
          { this.props.bulkSendSplit && this.props.canAccessBulkSendUI
             && this.makeFilter('documentsbulk', 'Bulk send', bulkDot)
           }
          { allTeamDocsFilter }
          { this.makeFilter('documentsoutforsignature', 'Out for signature', outforsignatureDot) }
          { this.makeFilter('documentsawaiting', 'Awaiting my signature', awaitingDot) }
          { completedFilter }
          { this.makeFilter('documentsdeclined', 'Declined', declinedDot) }
          { this.makeFilter('documentstemplates', 'Templates', templatesDot) }
          { this.makeFilter('documentstemplatelinks', 'Template links', templatelinksDot) }
          { this.makeFilter('documentsdrafts', 'Draft', draftsDot) }
        </div>
      );

      qaAttribute = 'documents-left-menu';
    }

    if (!this.props.canAccessAdminConsole) {
      manageTeamLink = (
        <div id='manageteam' className={this.getItemClassName('manageteam')}>
          <div className='m-app-leftmenu--section--title m-app-leftmenu--team'>
            <a href={teamUrl}><span>Team</span></a>
          </div>
        </div>
      );
    }

    const res = (
      <div className='m-app-leftmenu'>

        { sendFax }
        { recvFax }
        { signDocs }
        { templates }

        <div id='documents' className={this.getItemClassName('documents')}>
          <div className='m-app-leftmenu--section--title m-app-leftmenu--documents'>
            <a data-qa-ref={qaAttribute} href={docsUrl}><span>{ documentsName }</span></a>
          </div>
          <div className='m-app-leftmenu--section--items'>
            {siteSpecificFilters}
          </div>
        </div>

        { manageTeamLink }

        <div id='manage_integrations' className={this.getItemClassName('manage_integrations')}>
          <div className='m-app-leftmenu--section--title m-app-leftmenu--integrations'>
            <a href={integrationsUrl}><span>Integrations</span></a>
          </div>
        </div>

        { getFreePages }

        { faxNumbers }

      </div>
    );

    return res;
  },

});

export default AppLeftMenu;
